import * as React from 'react'
import Box from '@mui/material/Box'
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutline'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { Link, Navigate } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import { useCompleteVendorFlow } from 'vendors/queries/useVendorQuery'
import { useAuth0 } from '@auth0/auth0-react'
import CircularProgress from '@mui/material/CircularProgress'
import { useTranslation } from 'react-i18next'
import Grow from '@mui/material/Grow'

const IconBackground = styled(Box)(({ theme: { spacing } }) => ({
  width: 204,
  height: 190,
  borderRadius: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: spacing(4)
}))

const VendorWizardDone = () => {
  const { user } = useAuth0()
  const { mutate, isError, isPending: isLoading, isSuccess } = useCompleteVendorFlow(user?.name ?? '')
  const { t } = useTranslation()

  React.useEffect(() => {
    mutate()
  }, [mutate])

  React.useEffect(() => {
    if (isSuccess) {
      sessionStorage.clear()
    }
  })

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (isError) {
    return <Navigate to={`/error`} />
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', mt: 5, px: 2 }}>
      <Grow in={true}>
        <IconBackground>
          <CheckCircleIcon sx={{ height: 144, width: 144, color: 'success.light' }} />
        </IconBackground>
      </Grow>
      <Typography variant="h4" sx={{ fontWeight: 'fontWeightLight' }} gutterBottom>
        {t('that-is-it')}
      </Typography>
      <Typography sx={{ textAlign: 'center', maxWidth: '65ch', mb: 4 }} color="textSecondary">
        {t('company-information-saved-text')}
      </Typography>
      <Button variant="contained" component={Link} to={`/vendors`}>
        {t('your-front-page')}
      </Button>
    </Box>
  )
}

export default VendorWizardDone
